import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { calendarUtils, selectors } from '@fernleaf/util';
import { 
    getMenus, showProducts, getCalendar, getAllMenusURL, getSearch,
    getItemOrderControls, getSystemControls,
    getShowMainPage,
    setShowMainPage
} from '../store/redux';
import { anyAvailable } from '../stockControl/stockControl';

import classes from './Main.module.css';

const isPictureSection = ( section ) => [ 'Picture', 'Link' ].includes( section.type );

const Main = ( { location, history } ) => {
    const dispatch = useDispatch();
    const user = useSelector( selectors.getUser );
    const systemControls = useSelector( getSystemControls );
    const calendar = useSelector( getCalendar );
    const menus = useSelector( getMenus );
    const allMenusURL = useSelector( getAllMenusURL );
    const search = useSelector( getSearch );
    const itemOrderControls = useSelector( getItemOrderControls );
    const showMainPage = useSelector( getShowMainPage );
    const [ selectedMenu, setSelectedMenu ] = useState( null );

    useEffect( () => {
        if ( location.pathname !== '/shop' && location.pathname !== '/' ) {
            history.push( '/' );
        }
    }, [ location, history ] );

    useEffect( () => {
        if ( search || ( user && user.isAdmin && ! showMainPage ) ) {
            history.push( '/products' );
        }
    }, [ search, user, showMainPage, history, dispatch ] );

    const showSection = useCallback(
        ( section ) => ( e ) => {
            e.stopPropagation();
            dispatch( setShowMainPage( false ) ); // Make sure main page request is cancelled
            dispatch( showProducts( section._id ) );
            history.push( '/products' );
        }
    , [ history, dispatch ] );
    
    const menuLink = useCallback( 
        ( section ) => ( e ) => {
            e.stopPropagation();
            setSelectedMenu( section.menuId )
        } 
    , [ setSelectedMenu ] );

    if ( ! systemControls ) {
        return null;
    }

    let sections = [];
    for ( const menu of menus || [] ) {
        if ( menu.linkURL ) {
            sections.push( { 
                type: 'Link',
                url: menu.linkURL,
                menuId: menu.id,
                _id: sections.length
            } );
        }
    }

    for ( const menu of menus || [] ) {
        sections = sections.concat( menu.sections.filter(
            section => {
                if ( ! user.isAdmin && menu.type === 'Admin' ) {
                    return false;
                }
                if ( selectedMenu && section.menuId !== selectedMenu ) {
                    return false;
                }
                if ( systemControls.storeOrder ) {
                    if ( menu.minLeadTime.units === 'Minutes' || section.note === 'available today' ) {
                        return false;
                    }
                }
                if ( section.note !== 'available today' ) {
                    return true;
                }
                return calendar && calendarUtils.canOrderForToday( calendar );
            }
        ) );
    }
    if ( selectedMenu ) {
        sections.push( {
            type: 'Link',
            url: allMenusURL,
            _id: sections.length
        })
    }

    let itemSection = 1;

    return ( sections.length === 0 ? null :
        <section className={ classes.Main }>
            { sections.map( section => section.url && ( 
                isPictureSection( section ) || 
                ( user && user.isAdmin && section.items.length > 0 ) ||
                ( ! user.isAdmin && itemOrderControls && section.items.filter( 
                    variation => anyAvailable( variation, itemOrderControls ) ).length > 0 ) 
            ) &&
                <div key={ section._id } 
                    onClick={ isPictureSection( section ) 
                        ? menuLink( section )
                        : showSection( section ) 
                    } 
                    className={ `${ classes.Section } ${ isPictureSection( section ) ? '' :
                        itemSection++ % 2 === 0 ? classes.Even : classes.Odd }` }
                >
                    <div className={ isPictureSection( section ) ? 
                            classes.PictureSectionDiv : classes.SectionPictureDiv
                    } >
                        <img src={ section.url } alt={ section.url }
                            className={ isPictureSection( section ) ? 
                                classes.PictureSection : classes.SectionPicture
                            }
                        />
                        { section.type === 'Items' &&
                            <div className={ classes.SectionHeader }>{ section.header }</div>
                        }
                    </div>
                </div>
            ) }
        </section>
    );
};

export default withRouter( Main );